'use client'

import React, { useEffect, useState } from 'react'
import TitleAttrSingle from './TitleAttrSingle';
import AccordionSinglePost from './AccordionSinglePost';

const isBrowser = typeof window !== 'undefined'

export default function Programmes({data}) {

    const [activeAll, setActiveAll] = useState(false);

    useEffect(() => {
        if (isBrowser) {
            import("preline/preline").then((module) => {
                // Once loaded, call autoInit after a short delay
                setTimeout(() => {
                    window.HSStaticMethods.autoInit();
                }, 100);
            });
        }
    }, []);

    const showAllAccourdions = () => {
        if(activeAll === true){
            setActiveAll(false);
        }else{
            setActiveAll(true);
        }
    }

    return (
        data?.programmes.length !== 0 && (
            <div className='flex flex-col gap-4'>
                <div className='flex items-center justify-between'>
                    <TitleAttrSingle>{data?.title_programme}</TitleAttrSingle>
                    {/* <span onClick={showAllAccourdions} className='text-gray-500 textsm underline cursor-pointer'>
                        {activeAll === false ? 'Expand all' : 'Collect all'}
                    </span> */}
                </div>
                <div className="hs-accordion-group">
                    {data?.programmes.map((programme, index) => (
                        <AccordionSinglePost key={index} data={programme} active={index == 0 || activeAll === true ? 'active': ''} />
                    ))}
                </div>
            </div>
        )
    )
}
